import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    color: `${theme.palette.text.primary} !important`,
    backgroundColor: "transparent",
    boxShadow: "none",
    "&:before": {
      display: "none",
    },
  },
  expanded: {
    margin: "auto !important",
    transform: "none",
  },
  summary: {
    paddingLeft: "40px",
    width: "max-content",
  },
  summaryContent: {
    margin: "22px 0 !important",
  },
  summaryExpandIcon: {
    padding: 0,
    position: "absolute",
    left: 0,
    transform: "rotate(90deg) !important",
    backgroundColor: theme.palette.gray.light,
    color: theme.palette.text.primary,
    borderRadius: "50%",
  },
  expandIcon: {
    transition: "transform 0.3s linear",
    color: theme.palette.events.lightBlack,
    borderRadius: "50%",
    background: theme.palette.events.grayShade1,

    "&.expanded": {
      transform: "rotateZ(90deg)",
    },
  },
  detailsRoot: {
    padding: 0,
  },
  loadMoreContainer: {
    padding: "0px 0px 10px 0px",
  },
}));
